export default {
  LembrarSenha: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "lembrar-senha"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/LembrarSenha.js
// module id = h1e6
// module chunks = 32